import type { CheckoutDraft, PaymentMethod } from '../types'

export interface PaymentResult { approved: true; transactionId: string; amount: number; method: PaymentMethod }

export const mockPaymentService = {
  async pay(draft: CheckoutDraft, method: PaymentMethod): Promise<PaymentResult> {
    if (!draft || draft.total <= 0) throw new Error('결제 정보를 확인해 주세요.')
    await new Promise((resolve) => setTimeout(resolve, 850))
    return { approved: true, transactionId: `MOCK-${Date.now()}`, amount: draft.total, method }
  },
}

export const applyCoupon = (subtotal: number, code: string) => code.trim().toUpperCase() === 'OHMY7' ? Math.min(Math.round(subtotal * 0.07), 30000) : 0
